/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_S3_BodyInputs */

const en_landing_guide_s3_body = /** @type {(inputs: Landing_Guide_S3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Because text holds up and edits stay local, the model suits work that goes through many rounds of feedback.`)
};

const zh_landing_guide_s3_body = /** @type {(inputs: Landing_Guide_S3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`因为文字稳定、编辑局部可控，Ideogram 4.5 特别适合需要多轮反馈修改的工作。`)
};

/**
* | output |
* | --- |
* | "Because text holds up and edits stay local, the model suits work that goes through many rounds of feedback." |
*
* @param {Landing_Guide_S3_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_s3_body = /** @type {((inputs?: Landing_Guide_S3_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_S3_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_s3_body(inputs)
	return zh_landing_guide_s3_body(inputs)
});
export { landing_guide_s3_body as "landing.guide.s3_body" }